import { PrintDataEntitas } from "@/domain/entities/Booking";
import jsPDF from "jspdf";
import { startCase } from "lodash";
import moment from "moment";

let translate: any;

export const ursaSla = (
  params: {
    doc: jsPDF | any;
    startX: number;
    startY: number;
    data: PrintDataEntitas;
  },
  estimateSla: string,
  coor: {
    startX: number;
    startY: number;
  },
  translate: any
) => {
  // URSA CODE
  const isNewUrsaCode =
    params.data.sttOperationArea !== params.data.sttDistrictUrsaCode;
  params.doc.setFont("Montserrat", "bold");
  params.doc.setTextColor("#333333");
  params.doc.setFontSize(isNewUrsaCode ? 12 : 20);
  params.doc.text(
    params.data.sttOperationArea || params.data.sttDistrictUrsaCode,
    coor.startX + 78,
    coor.startY + (isNewUrsaCode ? 27 : 29)
  );

  const isInterpack = params.data.sttProductType === "INTERPACK";

  if (isInterpack) {
    // CREATED AT
    params.doc.setFont("Montserrat", "bold");
    params.doc.setTextColor("#333333");
    params.doc.setFontSize(6);
    params.doc.text(
      startCase(translate("receipt.createdAtV2")),
      coor.startX + 78,
      coor.startY + 33
    );
    params.doc.text(":", coor.startX + 90, coor.startY + 33);
    params.doc.setFont("Montserrat", "normal");
    params.doc.text(
      `${moment(params.data.sttCreatedAt).format("DD/MM/YYYY")}`,
      coor.startX + 91.5,
      coor.startY + 33
    );

    // CREATED AT
    params.doc.setFont("Montserrat", "bold");
    params.doc.setTextColor("#333333");
    params.doc.setFontSize(6);
    params.doc.text(
      startCase(translate("receipt.estimation")),
      coor.startX + 78,
      coor.startY + 37
    );
    params.doc.text(":", coor.startX + 90, coor.startY + 37);
    params.doc.setFont("Montserrat", "normal");

    // check valid date
    const parsed = new Date(params.data.estimateSla);
    const isValidDate = !isNaN(parsed.getTime());
    params.doc.text(
      moment(
        isValidDate ? params.data.estimateSla : params.data.estimateSlaMaxDate
      ).format("DD/MM/YYYY"),
      coor.startX + 91.5,
      coor.startY + 37
    );

    params.doc.setFont("Montserrat", "normal");
    params.doc.setTextColor("#333333");
    params.doc.setFontSize(4);
    params.doc.text(
      translate("receipt.customSla"),
      coor.startX + 78,
      coor.startY + 39
    );
  } else {
    // CREATED AT
    params.doc.setFont("Montserrat", "bold");
    params.doc.setTextColor("#333333");
    params.doc.setFontSize(6);
    params.doc.text(
      startCase(translate("receipt.createdAt")),
      coor.startX + 78,
      coor.startY + 33
    );
    params.doc.text(":", coor.startX + 87.5, coor.startY + 33);
    params.doc.setFont("Montserrat", "normal");
    params.doc.text(
      `${moment(params.data.sttCreatedAt).format("DD/MM/YYYY")}`,
      coor.startX + 89,
      coor.startY + 33
    );

    // CREATED AT
    params.doc.setFont("Montserrat", "bold");
    params.doc.setTextColor("#333333");
    params.doc.setFontSize(6);
    params.doc.text(
      startCase(translate("receipt.estimation")),
      coor.startX + 78,
      coor.startY + 37
    );
    params.doc.text(":", coor.startX + 87.5, coor.startY + 37);
    params.doc.setFont("Montserrat", "normal");

    // check valid date
    const parsed = new Date(params.data.estimateSla);
    const isValidDate = !isNaN(parsed.getTime());
    params.doc.text(
      moment(
        isValidDate ? params.data.estimateSla : params.data.estimateSlaMaxDate
      ).format("DD/MM/YYYY"),
      coor.startX + 89,
      coor.startY + 37
    );
  }
};
